// @ts-check

import 'chosen-js';
import angular from 'angular';
import moment from 'moment';
import * as requestClaimsSuccess from '../../../state/user/user.actions';
import AppSettings from '../../../app.settings';
import Auth from '../../../auth';

export class ProfileController {
  constructor(
    $scope,
    $rootScope,
    $window,
    $uibModal,
    usersService,
    languagesService,
    gettext,
    gettextCatalog,
    $ngRedux,
    $filter,
    navService,
  ) {
    'ngInject';

    this.$filter = $filter;
    this.$scope = $scope;
    this.store = $ngRedux;
    this.requestClaimsSuccess = requestClaimsSuccess;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.usersService = usersService;
    this.languagesService = languagesService;
    this.gettext = gettext;
    this.gettextCatalog = gettextCatalog;
    this.singleSignOnFlag = $scope.$parent.show.singleSignOnFlag;

    this.landingPages = (AppSettings.LandingPages || []).filter((option) =>
      navService.isValidState(option.state),
    );

    this.prefixOP = [
      {
        lookupCode: 'Mr',
        description: gettext('Mr.'),
      },
      {
        lookupCode: 'Ms',
        description: gettext('Ms.'),
      },
      {
        lookupCode: 'Dr',
        description: gettext('Dr.'),
      },
      {
        lookupCode: 'Mrs',
        description: gettext('Mrs.'),
      },
    ];

    this.measureUnitOptions = [
      {
        option: 'metric',
        des: gettext('Metric'),
      },
      {
        option: 'imperial',
        des: gettext('Imperial'),
      },
      {
        option: 'none',
        des: gettext('None'),
      },
    ];

    this.dateOptions = [
      {
        option: 'DD/MM/YYYY',
        des: gettext('DD/MM/YYYY'),
      },
      {
        option: 'MM/DD/YYYY',
        des: gettext('MM/DD/YYYY'),
      },
      {
        option: 'YYYY/MM/DD',
        des: gettext('YYYY/MM/DD'),
      },
      {
        option: 'DD.MM.YYYY',
        des: gettext('DD.MM.YYYY'),
      },
    ];

    this.mapViewOptions = [
      {
        option: 'streets',
        des: gettext('Streets'),
      },
      {
        option: 'satellite',
        des: gettext('Satellite'),
      },
    ];

    this.languageOptions = languagesService.getSupportedLanguages();
    this.forms = {};
    this.pass = {
      ConfirmPassword: '',
      NewPassword: '',
      OldPassword: '',
    };
    this.passwordPattern = /^.{12,}$/;

    // Phone Input Requirements
    this.phonePattern = /^[0-9]{1,15}$/;
    this.min = 7;
    this.max = 15;

    this.personalErrorFlag = false;
    this.personalErrorText = '';
    this.personalSuccessFlag = false;
    this.emailErrorFlag = false;
    this.emailErrorText = '';
    this.passwordErrorFlag = false;
    this.passwordErrorText = '';
    this.passwordSuccessFlag = false;
  }

  $onInit() {
    // to get user information from the server
    this.getUserInfo();

    // Set default map view
    if (!this.editUser.claims.data.mapView) {
      this.editUser.claims.data.mapView = 'streets';
    }

    this.unsubscribe = this.store.connect(
      () => {
        return {};
      },
      {
        ...requestClaimsSuccess,
      },
    )(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getUserInfo() {
    this.user = this.$rootScope.currentUser;
    this.setAndFormatDates();
    this.editUser = angular.copy(this.user);
    this.updated = {
      email: this.user.email,
    };
  }

  // apply filter in js to rerun when dataformat changed, as in html will run once or when date changes
  setAndFormatDates() {
    this.lastLoginAt = this.$filter('TableDateFilter')(this.user.lastLoginAt);
    this.updatedAt = this.$filter('TableDateFilter')(this.user.updatedAt);
  }

  submitPersonalInfo() {
    this.resetFlags();

    this.forms.userForm.$setSubmitted();

    if (this.forms.userForm.$invalid || this.upload) {
      return;
    }

    this.upload = true;

    const claims = this.editUser.claims.data;

    for (const key in claims) {
      if (!claims[key]) {
        delete claims[key];
      }
    }

    this.usersService
      .updateUserClaims(claims)
      .then(
        (response) => {
          this.upload = false;
          this.personalSuccessFlag = true;
          this.user = angular.copy(this.editUser);
          this.forms.userForm.$setPristine();
          this.requestClaimsSuccess(response);
          this.$rootScope.currentUser.claims.data = response.data;
          this.languagesService.setCurrentLanguage(response.data.language);
          moment.locale(response.data.language);
        },
        (error) => {
          let errorMsg = this.gettextCatalog.getString(
            'An error occurred while updating your profile',
          );
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = `${
                error.data.message
              } ${error.status.toString()} - ${error.statusText.toString()}`;
            } else {
              errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
            }
          } else {
            errorMsg += this.gettextCatalog.getString('. Please try again later.');
          }
          this.personalErrorFlag = true;
          this.personalErrorText = errorMsg;
        },
      )
      .finally(() => {
        this.upload = false;
        this.getUserInfo();
      });
  }

  submitEmail() {
    if (this.forms.emailForm.email.$invalid || this.emailChanging) {
      return;
    }

    this.item = {};

    angular.copy(this.updated, this.item);

    const modalInstance = this.$uibModal.open({
      template: require('./email/email.modal.html'),
      controller: 'EmailConfirmModalCtrl as vm',
      resolve: {
        item: () => {
          return this.item;
        },
      },
    });

    modalInstance.result.then(
      () => {
        // after confirm
        // sending the verficaton email to user
        const newemail = {
          email: this.updated.email,
        };

        this.resetFlags();

        this.emailChanging = true;

        return this.usersService.changeEmail(newemail).then(
          () => {
            this.emailChanging = false;
            Auth.manager.removeUser();
            this.$window.location.href = 'LogoffMessage';
          },
          (error) => {
            let errorMsg = this.gettextCatalog.getString(
              'An error occurred while updating your email',
            );

            if (error.data || error.status) {
              if (error.data.message) {
                errorMsg = `${
                  error.data.message
                } ${error.status.toString()} - ${error.statusText.toString()}`;
              } else {
                errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
              }
            } else {
              errorMsg += this.gettextCatalog.getString('. Please try again later.');
            }
            this.emailErrorFlag = true;
            this.emailErrorText = errorMsg;
            this.emailChanging = false;
          },
        );
      },
      () => {
        // change was cancelled
      },
    );
  }

  setUsersDateFormat() {
    this.editUser.claims.data = {
      ...this.editUser.claims.data,
      ...{ dateFormat: this.dateFormat },
    };
  }

  submitPasswordInfo() {
    if (this.forms.userPassword.$invalid || this.upload) {
      this.resetFlags();
      return;
    }

    if (this.pass.NewPassword === this.pass.OldPassword) {
      this.passwordErrorFlag = true;
      this.passwordErrorText = this.gettextCatalog.getString(
        'New password cannot match current password',
      );
      return;
    }

    if (this.pass.ConfirmPassword !== this.pass.NewPassword) {
      this.resetFlags();
      return;
    }

    this.upload = true;
    this.resetFlags();

    this.usersService
      .changePassword({
        CurrentPassword: this.pass.OldPassword,
        NewPassword: this.pass.NewPassword,
      })
      .then(
        () => {
          this.passdone = true;
          this.user.updatedAt = Date.now();
          this.passwordSuccessFlag = true;
          this.forms.userPassword.$setPristine();
          this.pass.OldPassword = '';
          this.pass.NewPassword = '';
          this.pass.ConfirmPassword = '';
          this.usersService.getCurrentUser(); // update currentUser object with new "last updated" value
        },
        () => {
          this.resetFlags();
          this.passwordErrorFlag = true;
          this.passwordErrorText = this.gettextCatalog.getString('Invalid current password');
          this.passdone = false;
        },
      )
      .finally(() => {
        this.upload = false;
      });
  }

  changeTab() {
    this.getUserInfo();
    this.resetFlags();
  }

  resetFlags() {
    this.personalErrorFlag = false;
    this.personalErrorText = '';
    this.personalSuccessFlag = false;
    this.emailErrorFlag = false;
    this.emailErrorText = '';
    this.emailSuccessFlag = false;
    this.passwordErrorFlag = false;
    this.passwordErrorText = '';
    this.passwordSuccessFlag = false;
  }
}

export function EmailConfirmModalCtrl($scope, $uibModalInstance, item) {
  'ngInject';

  this.item = item;
  this.confirm = () => {
    $uibModalInstance.close();
  };

  this.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
}

export const ProfileComponent = {
  template: require('../profile.html'),
  bindings: {},
  controller: ProfileController,
  controllerAs: 'vm',
};
